import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
// Single shared Dynamic wrapper around the paywall modal.
export const LimitedFreeTierGateModalDynamic = Dynamic(async () => {
    const { LimitedFreeTierGateModal } = await import('#pplx/frontend/apps/ask/billing/checkout/modals/LimitedFreeTierGateModal.js');
    return { default: LimitedFreeTierGateModal };
});
//# sourceMappingURL=LimitedFreeTierGateModalDynamic.js.map